import { useEffect, useState } from "react";
import { Flame, Share2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/apiClient";

export function Medal({ days, earned, size = 64 }) {
  return (
    <div
      data-testid={`badge-medal-${days}`}
      style={{ width: size, height: size }}
      className={`rounded-full flex flex-col items-center justify-center border-2 transition-colors ${
        earned ? "border-[#D4AF37] bg-[#D4AF37]/15 shadow-[0_0_24px_rgba(212,175,55,0.35)]" : "border-[#D4AF37]/20 bg-[#0B0F19] opacity-50"
      }`}
    >
      <span className={`font-display leading-none ${earned ? "gold-text" : "text-[#A7B0C0]"}`} style={{ fontSize: size * 0.36 }}>{days}</span>
      <span className="text-[8px] tracking-[0.2em] text-[#A7B0C0] mt-0.5">DAYS</span>
    </div>
  );
}

export default function StreakBadges() {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/streak").then(({ data }) => setS(data)).catch(() => {});
  }, []);
  if (!s) return null;
  const top = [...s.badges].reverse().find((b) => b.earned);

  const share = async () => {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/share/badge/${s.code}?d=${top.days}`;
    const text = `I earned the ${top.name} badge on Astra: ${top.days} days in a row with the stars.`;
    try {
      if (navigator.share) await navigator.share({ title: "My Astra streak", text, url });
      else {
        await navigator.clipboard.writeText(`${text} ${url}`);
        toast.success("Badge link copied");
      }
    } catch (e) {
      if (e?.name !== "AbortError") toast.error("Couldn't share right now");
    }
  };

  return (
    <div data-testid="streak-badges" className="bg-[#0F1523] border border-[#D4AF37]/20 rounded-2xl p-5 mb-4">
      <div className="flex items-center justify-between mb-4">
        <p className="flex items-center gap-2 text-lg"><Flame size={17} className="gold-text" /> Streak badges</p>
        <p className="text-xs text-[#A7B0C0]" data-testid="streak-summary">Now {s.count} · Best {s.best}</p>
      </div>
      <div className="flex justify-around">
        {s.badges.map((b) => (
          <div key={b.days} className="flex flex-col items-center gap-1.5">
            <Medal days={b.days} earned={b.earned} />
            <span className={`text-xs ${b.earned ? "text-starlight" : "text-[#A7B0C0]"}`}>{b.name}</span>
          </div>
        ))}
      </div>
      {top && s.code ? (
        <button
          data-testid="btn-share-badge"
          onClick={share}
          className="mt-4 w-full flex items-center justify-center gap-2 border border-[#D4AF37]/40 gold-text py-2.5 rounded-full hover:border-[#D4AF37] transition-colors"
        >
          <Share2 size={15} /> Share my {top.name} badge
        </button>
      ) : (
        <p className="mt-4 text-center text-xs text-[#A7B0C0]">Open your reading 7 days in a row to earn your first badge.</p>
      )}
    </div>
  );
}
